<h2 class="modal-title" mat-dialog-title>
    <span>Przygotowanie wydruku<span *ngIf="configurationShortcode"> dla konfiguracji <b>{{configurationShortcode}}</b></span></span>
</h2>
<mat-dialog-content>
    <mat-checkbox [(ngModel)]="clientInfoFormEnabled" class="enable-client-info-checkbox">Oferta z danymi klienta i rabatem</mat-checkbox>
    <div [class.client-info-form--disabled]="!clientInfoFormEnabled" class="client-info-form">
        <div class="offer-info-section">
            <mat-card class="mat-elevation-z4">
                <mat-card-title>Dane oferty</mat-card-title>
                <mat-card-content class="offer-info-section__fields">
                    <mat-form-field appearance="outline">
                        <mat-label>Czas ważności</mat-label>
                        <input [(ngModel)]="offerDurationInDays" [disabled]="!clientInfoFormEnabled" matInput>
                        <mat-hint>Czas ważności oferty w dniach</mat-hint>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="comment-field">
                        <mat-label>Uwagi</mat-label>
                        <textarea name="comment" [(ngModel)]="comment" [disabled]="!clientInfoFormEnabled" class="comment-field__comment-textarea" matInput #commentInput rows="5"></textarea>
                        <mat-hint align="end">{{commentInput.value.length}} / 300</mat-hint>
                    </mat-form-field>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="client-info-section">
            <mat-card class="mat-elevation-z4">
                <mat-card-title>Dane klienta</mat-card-title>
                <mat-card-content class="client-info-section__fields">
                    <mat-form-field appearance="outline">
                        <mat-label>Imię</mat-label>
                        <input [(ngModel)]="name" [disabled]="!clientInfoFormEnabled" matInput>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Nazwisko / Nazwa</mat-label>
                        <input [(ngModel)]="fullName" [disabled]="!clientInfoFormEnabled" matInput>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Numer telefonu</mat-label>
                        <input [(ngModel)]="phoneNumber" [disabled]="!clientInfoFormEnabled" matInput>
                    </mat-form-field>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="address-info-section">
            <mat-card class="mat-elevation-z4">
                <mat-card-title>Adres inwestycji</mat-card-title>
                <mat-card-content class="address-info-section__fields">
                    <mat-form-field appearance="outline">
                        <mat-label>Adres</mat-label>
                        <input [(ngModel)]="address" [disabled]="!clientInfoFormEnabled" matInput>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Miejscowość</mat-label>
                        <input [(ngModel)]="city" [disabled]="!clientInfoFormEnabled" matInput>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Kod pocztowy</mat-label>
                        <input [(ngModel)]="postCode" [disabled]="!clientInfoFormEnabled" matInput>
                    </mat-form-field>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="price-info-section">
            <mat-card class="mat-elevation-z4">
                <mat-card-title>Wycena</mat-card-title>
                <mat-card-content>
                    <table class="mat-table price-info-section__table" >
                        <tr class="mat-header-row">
                            <th class="mat-header-cell"></th>
                            <th class="mat-header-cell">Cena netto</th>
                            <th class="mat-header-cell">Ilość</th>
                            <th class="mat-header-cell">Wartość netto</th>
                        </tr>
                        <tr class="mat-row">
                            <td class="mat-cell">{{positionName}}</td>
                            <td class="mat-cell">
                                <mat-form-field appearance="outline" class="no-spin-buttons align-text-center">
                                    <input [(ngModel)]="nettoPrice" type="number" [disabled]="!clientInfoFormEnabled" matInput (blur)='changedInputData("default")'>
                                </mat-form-field>
                            </td>
                            <td class="mat-cell">
                                <mat-form-field appearance="outline" class="align-text-center">
                                    <input [(ngModel)]="amount" min="0" type="number" [disabled]="!clientInfoFormEnabled" matInput (blur)='changedInputData("default")'>
                                </mat-form-field>
                            </td>
                            <td class="mat-cell align-text-right">{{ getNettoPrice() | currency: currency}}</td>
                        </tr>
                        <tr class="mat-row">
                            <td class="mat-cell">Rabat</td>
                            <td class="mat-cell">
                            </td>
                            <td class="mat-cell">
                            </td>
                            <td class="mat-cell">
                                <mat-form-field appearance="outline" class="align-text-center">
                                    <input [(ngModel)]="discountPercent" type="number" min="0" max="100" [disabled]="!clientInfoFormEnabled" matInput (input)='changedInputData("discountPercent")'>
                                    <span matSuffix>%</span>
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="align-text-center">
                                    <input [(ngModel)]="discountCash" type="number" [disabled]="!clientInfoFormEnabled" matInput (input)='changedInputData("discountCash")'>
                                    <span matSuffix>zł</span>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr class="mat-row">
                            <td class="mat-cell">Usługi dodatkowe</td>
                            <td class="mat-cell">
                            </td>
                            <td class="mat-cell">
                            </td>
                            <td class="mat-cell">
                                <mat-form-field appearance="outline" class="no-spin-buttons align-text-center">
                                    <input [(ngModel)]="additionalServicesPrice" class="no-spin-buttons" type="number" [disabled]="!clientInfoFormEnabled" matInput (blur)='changedInputData("default")'>
                                    <span matSuffix>zł</span>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr class="mat-row">
                            <td class="mat-cell">Razem netto</td>
                            <td class="mat-cell">
                            </td>
                            <td class="mat-cell">
                            </td>
                            <td class="mat-cell align-text-right">
                                <mat-form-field appearance="outline" class="no-spin-buttons align-text-center">
                                    <input [ngModel]="fullNettoPrice | currency: currency : false : true" (ngModelChange)='fullNettoPrice=$event' class="no-spin-buttons" type="number" [disabled]="!clientInfoFormEnabled" matInput (input)='changedInputData("fullNettoPrice")'>
                                    <span matSuffix>zł</span>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr class="mat-row">
                            <td class="mat-cell">VAT</td>
                            <td class="mat-cell">
                                <mat-form-field appearance="outline" class="align-text-center">
                                    <mat-select [(ngModel)]="selectedVat" [disabled]="!clientInfoFormEnabled" (selectionChange)='changedInputData("vat")'>
                                        <mat-option *ngFor="let vat of vats" [value]="vat.value">
                                            {{vat.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td class="mat-cell">
                            </td>
                            <td class="mat-cell align-text-right">
                                {{ vatPrice | currency: currency}}
                            </td>
                        </tr>
                        <tr class="mat-row">
                            <td class="mat-cell">Razem</td>
                            <td class="mat-cell">
                            </td>
                            <td class="mat-cell">
                            </td>
                            <td class="mat-cell align-text-right">
                                <mat-form-field appearance="outline" class="no-spin-buttons align-text-center">
                                    <input [ngModel]="fullPrice | currency: currency : false : true" (ngModelChange)='fullPrice=$event' class="no-spin-buttons" type="number" [disabled]="!clientInfoFormEnabled" matInput (input)='changedInputData("fullPrice")'>
                                    <span matSuffix>zł</span>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr class="mat-row">
                            <td class="mat-cell align-text-right">
                                <button mat-raised-button (click)='resetToDefaults()'>Resetuj cenę</button>
                            </td>
                        </tr>
                    </table>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close class="mat-elevation-z4">Anuluj</button>
    <button mat-raised-button color="primary" class="mat-elevation-z4 print-button" (click)="closeWithData()">{{clientInfoFormEnabled ? 'Generuj ofertę' : 'Generuj PDF' }}</button>
</mat-dialog-actions>
